import React, { Dispatch, SetStateAction } from 'react';
import ModalComponent from '../../../../components/ModalComponent';
import { Grid2 } from '@mui/material';
import {
  DefenseDeviceCategoryTypes,
  DefenseManufacturerTypes,
  IDefenseDeviceProps,
} from '../../../../services/Defense/Devices/types';
import TextFieldComponent from '../../../../components/TextFieldComponent';
import {
  convertDeviceCategory,
  convertManufacturer,
} from '../../../../converters/Defense/ConverterDefense';
import { t } from 'i18next';

interface DefenseDeviceDetailsModalProps {
  isOpen: boolean;
  selectedDevice?: IDefenseDeviceProps;
  setSelectedDevice?: Dispatch<SetStateAction<any>>;
  onClose?: () => void;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
}

const DefenseDeviceDetailsModal = ({
  isOpen,
  selectedDevice,
  setSelectedDevice,
  setIsOpen,
}: DefenseDeviceDetailsModalProps) => {
  const handleClose = () => {
    setIsOpen(false);
    if (setSelectedDevice) setSelectedDevice(undefined);
  };

  return (
    <ModalComponent
      onClose={handleClose}
      isOpen={isOpen}
      title={t('defensePages.deviceTable.detailsDefenseDeviceModal.title')}
    >
      <Grid2
        container
        direction={{ xs: 'column', lg: 'row' }}
        size={12}
        spacing={{ xs: 0, lg: 3 }}
        justifyContent="center"
        alignItems={{ xs: 'center', lg: 'normal' }}
      >
        <Grid2 size={{ xs: 12, lg: 6 }}>
          <TextFieldComponent
            label={t('defensePages.deviceTable.detailsDefenseDeviceModal.name')}
            value={selectedDevice?.name || 'Não Possui'}
            type={'text'}
            aria-readonly={true}
            slotProps={{
              inputLabel: {
                shrink: true,
              },
            }}
          />
          <TextFieldComponent
            label={t(
              'defensePages.deviceTable.detailsDefenseDeviceModal.model',
            )}
            value={selectedDevice?.model || 'Não Possui'}
            type={'text'}
            aria-readonly={true}
            slotProps={{
              inputLabel: {
                shrink: true,
              },
            }}
          />
          <TextFieldComponent
            label={t(
              'defensePages.deviceTable.detailsDefenseDeviceModal.brand',
            )}
            value={
              convertManufacturer(
                selectedDevice?.manufacturer as DefenseManufacturerTypes,
              ) || 'Não Possui'
            }
            type={'text'}
            aria-readonly={true}
            slotProps={{
              inputLabel: {
                shrink: true,
              },
            }}
          />
          <TextFieldComponent
            label={t(
              'defensePages.deviceTable.detailsDefenseDeviceModal.category',
            )}
            value={
              convertDeviceCategory(
                selectedDevice?.category as DefenseDeviceCategoryTypes,
              ) || 'Não Possui'
            }
            type={'text'}
            aria-readonly={true}
            slotProps={{
              inputLabel: {
                shrink: true,
              },
            }}
          />
          <TextFieldComponent
            label={t(
              'defensePages.deviceTable.detailsDefenseDeviceModal.status',
            )}
            value={selectedDevice?.isOnline ? 'Online' : 'Offline'}
            type={'text'}
            aria-readonly={true}
            slotProps={{
              inputLabel: {
                shrink: true,
              },
            }}
          />
        </Grid2>
        <Grid2 size={{ xs: 12, lg: 6 }}>
          <TextFieldComponent
            label={t(
              'defensePages.deviceTable.detailsDefenseDeviceModal.idDefense',
            )}
            value={selectedDevice?.defenseDeviceId || 'Não Possui'}
            type={'text'}
            aria-readonly={true}
            slotProps={{
              inputLabel: {
                shrink: true,
              },
            }}
          />
          <TextFieldComponent
            label={t('defensePages.deviceTable.detailsDefenseDeviceModal.type')}
            value={selectedDevice?.defenseType || 'Não Possui'}
            type={'text'}
            aria-readonly={true}
            slotProps={{
              inputLabel: {
                shrink: true,
              },
            }}
          />
          <TextFieldComponent
            label={t('defensePages.deviceTable.detailsDefenseDeviceModal.ip')}
            value={selectedDevice?.ip || 'Não Possui'}
            type={'text'}
            aria-readonly={true}
            slotProps={{
              inputLabel: {
                shrink: true,
              },
            }}
          />
          <TextFieldComponent
            label={t(
              'defensePages.deviceTable.detailsDefenseDeviceModal.protocol',
            )}
            value={selectedDevice?.protocol || 'Não Possui'}
            type={'text'}
            aria-readonly={true}
            slotProps={{
              inputLabel: {
                shrink: true,
              },
            }}
          />
        </Grid2>
      </Grid2>
    </ModalComponent>
  );
};

export default DefenseDeviceDetailsModal;
